export enum Specialities {
  Physician = "Physician",
  Student = "Student",
  Nurse = "Nurse",
  Other_HealthCare = "Other in Healthcare",
  Other = "Other",
}
